module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-262.808651af.jpg";